import React from "react";
import {  Card, CardBody } from "reactstrap";
import styles from '../../assets/css/Card.module.css';
import Modal from 'react-modal';
interface SelectAgencyModalProps {
  isOpen: boolean;
  toggle: () => void;
  agencies: any[];
  onSelectAgency: (id: string | number, userId?: string | number | undefined) => void;
  userId: number;
}

const SelectAgencyModal: React.FC<SelectAgencyModalProps> = ({ isOpen, toggle, agencies, onSelectAgency, userId }) => {
  // Dynamic column classes based on agency count - optimized for space usage
  const getColumnClass = () => {
    const count = agencies.length;
    if (count === 1) return "col-12";
    if (count === 2) return "col-6";
    if (count === 3) return "col-4";
    return "col-6 col-md-4 col-lg-3"; // 4 or more
  };

  // Dynamic modal class based on agency count
  const getModalClass = () => {
    const count = agencies.length;
    if (count === 1) return "advance-filter-modal single-agency";
    if (count === 2) return "advance-filter-modal two-agencies";
    if (count === 3) return "advance-filter-modal three-agencies";
    return "advance-filter-modal multiple-agencies"; // 4 or more
  };

  return (
    <Modal  isOpen={isOpen} toggle={toggle} size="xl" className={getModalClass()}>
       <div className="d-flex justify-content-between align-items-center pb-0">
        <h5>Select Agency</h5>
        <button onClick={toggle} className="btn-close" aria-label="Close Modal">
        </button>
      </div>
      <div style={{ 
        padding: agencies.length > 3 ? "20px 20px 10px 20px" : "20px" 
      }}>
        <div className="row justify-content-center" style={{ 
          maxHeight: "calc(100vh - 220px)",
          overflowY: "auto",
          overflowX: "hidden",
          margin: "0 -10px"
        }}>
          {agencies.map((agency, index) => {
            const isLastRow = agencies.length > 3 && index >= agencies.length - 4;
            const bottomMargin = isLastRow ? "10px" : "20px";
            
            return (
            <div key={agency.id} className={`${getColumnClass()}`} style={{ 
              padding: "0 10px",
              marginBottom: bottomMargin
            }} onClick={() => {
              onSelectAgency(agency.account_id, userId);
            }}>
              <Card className={styles.customCard} style={{ height: "100%", marginBottom: 0 }}>
                <img className="card-img-top img-fluid" src={agency.agency_logo} alt="" />
                <CardBody style={{ padding: '15px' }}>
                  <h4 style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontSize: "14px",
                    margin: 0
                  }}
                    title={agency.agency_name} className="card-title">{agency.agency_name}</h4>
                </CardBody>
              </Card>
            </div>
            );
          })}
        </div>
      </div>
    </Modal>
  );
};

export default SelectAgencyModal;
